import React from "react";
import { TextField, Grid, Box } from "@mui/material";
import { IconButton, Tooltip, Stack } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import GCData from "./GCDataGrid";
import moment from "moment";
import { useGridApiRef } from "@mui/x-data-grid-pro";

const PoVsGrn = ({ data, row = [], column = [] }) => {
  const apiRef = useGridApiRef();

  const handleExport = () => {
    apiRef.current.exportDataAsCsv(); // or exportDataAsExcel(), etc.
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  return (
    <Box>
      <Grid container spacing={1} mb={1}>
        {/* First Row */}
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="PO Voucher Type"
            value={data.VocTyp + data.VocName || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="GRN Voucher Type"
            value={data.GrnDocTyp + data.GRNName || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="GRN Amount"
            value={data.GRNAmt || 0}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="PO Voucher No"
            value={data.VocNo || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="GRN Voucher No"
            value={data.GrnDocNo || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="INV Amount"
            value={data.InvAmt || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="PO Date"
            value={moment(data.PODate).format("DD/MM/YYYY") || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="GRN Date"
            value={moment(data.GRNDate).format("DD/MM/YYYY") || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="Diff. Amount In Item INV Vs GRN"
            value={data.InvAmt - data.GRNAmt || 0}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        {/* Second Row */}
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="PO Net Amount"
            value={data.POAmt || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="Invoice Date"
            value={moment(data.InvDt).format("DD/MM/YYYY") || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="GRN Amount"
            value={data.GRNAmt || 0}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="PO No of Items"
            value={data.POLineItems || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="GRN No of Items"
            value={data.InvLineItems || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="PO Net Amount "
            value={data.POAmt}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="Invoice No"
            value={data.InvNo || 0}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>

        {/* Third Row */}
        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="Diff. Amount INV Vs PO"
            value={data.POLineItems - data.InvLineItems || 0}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>

        <Grid item xs={6} md={4} lg={4}>
          <TextField
            label="Diff. Amount PO Vs GRN"
            value={data.POAmt - data.GRNAmt || ""}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
      </Grid>
      <>
        <Stack direction={"row"} justifyContent={"flex-end"}>
          <Tooltip title="Export">
            <IconButton color="primary" size="small" onClick={handleExport}>
              <FileDownloadIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Print">
            <IconButton color="primary" size="small" onClick={handlePrint}>
              <PrintIcon />
            </IconButton>
          </Tooltip>
        </Stack>
        <GCData
          Row={row}
          Column={column}
          apiRef={apiRef}
          onRowClick={(e) => {}}
          height={"32vh"}
        />
      </>
      <Grid container spacing={1} mt={1} justifyContent={"end"}>
        {/* First Row */}
        <Grid item xs={4} md={1} lg={1}>
          <TextField
            label="PO Qty"
            value={row.reduce((acc, item) => acc + item?.POQty, 0)}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={4} md={1} lg={1}>
          <TextField
            label="GRN Qty"
            value={row.reduce((acc, item) => acc + item?.GRNQty, 0)}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={4} md={1} lg={1}>
          <TextField
            label="Variance Qty"
            value={row.reduce((acc, item) => acc + item?.DiffQty, 0)}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1} mt={1} justifyContent={"end"}>
        {/* First Row */}
        <Grid item xs={4} md={1} lg={1}>
          <TextField
            label="PO Amount"
            value={row.reduce((acc, item) => acc + item?.POAmt, 0)}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={4} md={1} lg={1}>
          <TextField
            label="GRN Amount"
            value={row.reduce((acc, item) => acc + item?.GRNAmt, 0)}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
        <Grid item xs={4} md={1} lg={1}>
          <TextField
            label="Variance Amount"
            value={row.reduce((acc, item) => acc + item?.DiffAmt, 0)}
            fullWidth
            readOnly
            size={"small"}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PoVsGrn;
